import { render } from "./App.vue?vue&type=template&id=dbb4fa9e"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=dbb4fa9e&lang=css"

import exportComponent from "C:\\Users\\TAT SING\\Desktop\\working area\\TatSingGroup-Web\\ts-consulting-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__